import CrudCustom from '../../../libs/custom/CrudCustom';

let JenisUsahaService = new CrudCustom('/jenis-usahas');
export default JenisUsahaService;
